var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('tablePtenAction',{attrs:{"typeList":"search"},on:{"setTitle":_vm.setTitle}}),_c('navbarPten',{attrs:{"menuIndex":"4"},on:{"actionClick":_vm.actionClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }